import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ExtraKey } from '@app/models/enums/extra-key.enum';
import { RescType } from '@app/models/enums/resc-type.enum';
import { AuthResource } from '@app/models/settings/auth-resource';
import { IncentiveModalComponent } from '@components/incentive-modal/incentive-modal.component';
import { BaseComponent } from '@core/component/base/base.component';
import { I18nService } from '@core/services/i18n/i18n.service';
import { isNumber, tranType } from '@core/utils';
import { ROUTER_UTILS } from '@core/utils/router.utils';
import { AuthService } from '@services/auth.service';
import { SystemService } from '@services/system.service';
import { toNumber, union } from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ThemeChangeComponent } from '@components/theme-change/theme-change.component';
import { TranslateModule } from '@ngx-translate/core';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
@Component({
  standalone: true,
  selector: 'app-header',

  imports: [CommonModule, TranslateModule, RouterModule, NzBadgeModule, NzLayoutModule, NzDropDownModule, NzGridModule, NzIconModule, NzMenuModule, ThemeChangeComponent, IncentiveModalComponent],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.less'],
})
export class HeaderComponent extends BaseComponent implements OnInit {
  @ViewChild('incentiveModal')
  incentiveModal!: IncentiveModalComponent;

  path = ROUTER_UTILS;
  isLoggedIn$!: Observable<boolean>;
  navList: Array<AuthResource> = [];

  incentiveCount = 0;
  incentiveEnable = false;

  currEnvVer = new BehaviorSubject<string>('');

  get rescType(): typeof RescType {
    return RescType;
  }

  get disableTheme(): boolean {
    return location.pathname.includes(this.path.business.incentive.shareMyecom);
  }

  get disableUserProfile(): boolean {
    return location.pathname.includes(this.path.business.bi);
  }

  constructor(
    authService: AuthService,
    i18nService: I18nService,
    private router: Router,
    private systemService: SystemService,
  ) {
    super(authService, i18nService);
    // this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe(e => {
    //   const navigation = router.getCurrentNavigation();
    //   console.log(navigation?.extras.state?.attrCfg);
    // });
  }
  onInentiveModalClose(showCount?: boolean): void {
    this.incentiveCount = showCount ? 1 : 0;
  }
  showIncentiveModal(): void {
    this.incentiveCount = 0;
    if (this.incentiveModal) {
      this.incentiveModal.handleShow();
    }
  }

  initNavList() {
    this.authService.getAuthRescList().subscribe(res => {
      this.navList = res
    });
  }
  ngOnInit(): void {
    this.isLoggedIn$ = this.authService.isLoggedInSubject;
    this.isLoggedIn$.subscribe(b => {
      if (b) {
        this.initNavList();
      }
    });
    this.systemService.getSysFeatures().subscribe(data => {
      this.currEnvVer.next(data['CUR_ENV_VER']);
    });
    this.authService.attrCfgSubject.subscribe(attrCfg => {
      if (tranType(this.attrCfg[ExtraKey.ICIS_ENABLE]) === true) {
        this.incentiveEnable = true;
        let timeout = toNumber(this.attrCfg[ExtraKey.ICIS_SHOW_DELAY]) * 1000;
        if (!isNumber(timeout)) {
          timeout = 10000;
        }
        setTimeout(() => {
          this.showIncentiveModal();
        }, timeout);
      } else {
        this.incentiveEnable = false;
        this.incentiveCount = 0;
      }
    });
  }

  logout() {
    this.authService.signOut();
  }

  navMenuClick(router: string) {
    this.router.navigate([router]);
  }

  hasChildrenNav(nav: AuthResource) {
    return (
      nav.type === RescType.ROUTE && nav.children && nav.children.length && nav.children.some(n => n.type === 'ROUTE')
    );
  }

  getChildrenNav(children: AuthResource[]) {
    return children.filter(nav => nav.type === RescType.ROUTE);
  }

  getChildrenAttrCfg(nav: AuthResource) {
    const attrCfg = union(
      nav.children?.filter(ele => ele.type === RescType.ATTR),
      this.navList.filter(ele => ele.type === RescType.ATTR),
    );
    return attrCfg.map(ele => ({ [ele.code]: ele.value }));
  }
}
